
// for debt payoff calculations
const ENTRY_ORDER = 0
const HIGH_INTEREST_FIRST = 1
const LOW_BAL_FIRST = 2

const payoffOrder = {
    ENTRY_ORDER,
    HIGH_INTEREST_FIRST,
    LOW_BAL_FIRST
}

module.exports.payoffOrder = payoffOrder

